import { useState } from "react"
import { useAppDispatch, useAppSelector } from '../../lib/redux/hooks';

import "react-datepicker/dist/react-datepicker.css";
import { CustomAccordion } from "../../ui/molecules/accordion";
import { useNavigate } from "react-router-dom";
import React from "react";
import Input from "../../ui/molecules/input/Input";
import TextArea from "../../ui/molecules/textArea/TextArea";

import './style.scss';
import { setContactEmail, setContactFax, setContactMobilePhone, setContactNote, setContactOfficePhone, setContactOtherEmail, setContactPec, setContactPersonalEmail, setContactPhone } from "./slice";


export function BoxRubrica() {
    const pathname = window.location.pathname
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const [expanded, setExpanded] = React.useState<string | false>("panel1");
    const handleToggleAccordion = (panel: string) => {
        setExpanded(expanded === panel ? false : panel);
    };
    return (
        <div style={{ padding: '24px' }} id="boxRubrica">

            <div className="mt-6">
                <CustomAccordion 
                    id="panel1"
                    title={<span className="text-uppercase text-white label-input">Contatti</span>} 
                    expanded={expanded === 'panel1'} 
                    onChange={() => handleToggleAccordion('panel1')}
                >

                        <div className="formRappLegale" style={{ display: 'flex', flex: 'wrap', gap: '24px' }}>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Telefono'} placeholder="Telefono" onChangeText={(text) =>  dispatch(setContactPhone(text)) } />
                            </div>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Telefono Ufficio'} placeholder="Telefono Ufficio" onChangeText={(text) => dispatch(setContactOfficePhone(text)) } />
                            </div>

                        </div>

                        <div className="formRappLegale mt-6" style={{ display: 'flex', flex: 'wrap', gap: '24px' }}>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Cellulare'} placeholder="Cellulare" onChangeText={(text) => dispatch(setContactMobilePhone(text)) } />
                            </div>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Fax'} placeholder="Fax" onChangeText={(text) => dispatch(setContactFax(text)) } />
                            </div>

                        </div>

                        <div className="formRappLegale mt-6" style={{ display: 'flex', flex: 'wrap', gap: '24px' }}>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Email'} placeholder="Email" onChangeText={(text) =>  dispatch(setContactEmail(text)) } />
                            </div>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Email Personale'} placeholder="Email Personale" onChangeText={(text) =>  dispatch(setContactPersonalEmail(text)) } />
                            </div>

                        </div>

                        <div className="formRappLegale mt-6" style={{ display: 'flex', flex: 'wrap', gap: '24px' }}>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'PEC'} placeholder="PEC" onChangeText={(text) => dispatch(setContactPec(text)) } />
                            </div>

                            <div style={{ flex: '1 1 auto' }}>
                                <Input label={'Altra Email'} placeholder="Altra Email" onChangeText={(text) => dispatch(setContactOtherEmail(text)) } />
                            </div>

                        </div>

                </CustomAccordion>
            </div>

            <div className="mt-6">
                <CustomAccordion 
                    id="panel2"
                    title={<span className="text-uppercase text-white label-input">Note</span>} 
                    expanded={expanded === 'panel2'} 
                    onChange={() => handleToggleAccordion('panel2')}
                >
                        <div className="formInOut">

                            <TextArea onChangeText={(text) => dispatch(setContactNote(text))} />
                        </div>

                </CustomAccordion>
            </div>


        </div >
    )
}